import {Component, OnInit} from '@angular/core';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {StudentService} from '../../shared/services/student.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../shared/services/alert.service';
import {Router} from '@angular/router';
import {CounsellorService} from '../../shared/services/counsellor.service';
import {StorageService} from '../../shared/services/storage.service';
import {StageService} from '../../shared/services/stage.service';
import {ReasonService} from '../../shared/services/reason.service';
import {SrMappingService} from '../../shared/services/sr-mapping.service';

@Component({
    selector: 'app-students',
    templateUrl: './students.component.html',
    styleUrls: ['./students.component.scss']
})

export class StudentsComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 30,
        pages: null
    };
    students = [];
    allStages = [];
    allReasons = [];
    reasonFollowups = [];
    followUps: any = [];
    modalType: any;
    selectedStudent: any;
    counsellors: any = [];
    counsellorsDetails: any = [];
    assignCounsellorForm: FormGroup;
    followUpForm: FormGroup;
    user: any;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private studentService: StudentService,
                private counsellorService: CounsellorService,
                private stageService: StageService,
                private reasonService: ReasonService,
                private srMappingService: SrMappingService,
                private alertService: AlertService) {
        this.user = StorageService.getItem('self');
        if (this.user.user_type === 'COUNSELLOR') {
            this.counsellorService.detail(this.user.userId).subscribe(data => {
                if (data) {
                    this.counsellorsDetails = data;
                }
            });


        } else {
            this.counsellorsDetails = '';


        }
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': ['']
        });
        this.assignCounsellorForm = this.fb.group({
            'assigned_to': ['', Validators.required]
        });
        /* this.followUpForm = this.fb.group({
             'follow_up': ['', Validators.required],
             'follow_up_remarks': [''],
         });*/
        this.followUpForm = this.fb.group({
            'subject': ['', Validators.required],
            'stage_id': ['', Validators.required],
            'reason_id': ['', Validators.required],
            'type': ['', Validators.required],
            'remark': [''],
        });


        this.get();
        this.getCounsellors();
        this.getAllStages();
        this.getAllReasons();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.students = [];
        this.studentService.get(params).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.students = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.students = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    getAllStages() {
        this.allStages = [];
        this.stageService.get({'page': -1}).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.allStages = data['data'];
            } else {
                this.allStages = [];
            }
        });
    }

    getAllReasons() {
        this.allReasons = [];
        this.reasonService.get({'page': -1}).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.allReasons = data['data'];
            } else {
                this.allReasons = [];
            }
        });
    }

    getReasonsFollowups(): void {
        this.followUpForm.patchValue({
            'reason_id': ''
        });
        this.reasonFollowups = [];
        const params = {
            'stages_id': (this.followUpForm && this.followUpForm.value && this.followUpForm.value.stage_id) ? this.followUpForm.value.stage_id : ''
        };

        this.srMappingService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.reasonFollowups = data['data'];

            }
        });
    }


    getStages() {
        this.counsellorService.get({'page': -1, 'user_type': 'COUNSELLOR'}).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.counsellors = data['data'];
            } else {
                this.counsellors = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }


    getCounsellors() {
        this.counsellorService.get({'page': -1, 'user_type': 'COUNSELLOR'}).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.counsellors = data['data'];
            } else {
                this.counsellors = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'name': (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : ''
        };
        this.get(params);
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.studentService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    viewCounsellorsModal(content, data) {
        this.selectedStudent = data;
        this.modalType = 'COUNSELLOR_ASSIGN';
        this.modalService.open(content, {size: 'lg'});
    }

    assignCounsellor() {
        this.submitted = true;
        if (!this.assignCounsellorForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'assigned_to': (this.assignCounsellorForm.value && this.assignCounsellorForm.value.assigned_to) ? this.assignCounsellorForm.value.assigned_to : ''
            };
            this.submitting = true;
            this.studentService.assignCounsellor(this.selectedStudent.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.assignCounsellorForm.reset();
                this.assignCounsellorForm.patchValue({
                    'assigned_to': ''
                });
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].assigned_to.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].assigned_to[0]);
                        return;
                    }
                }
            });
        }
    }

    changeFollowUp(content, data) {
        this.selectedStudent = data;
        this.modalType = 'FOLLOW_UP';

        this.modalService.open(content, {size: 'lg'});
    }

    followUp() {
        this.submitted = true;
        if (!this.followUpForm.valid) {
            return;
        }
        if (this.submitted) {
            const params: {} = {
                stage_id: (this.followUpForm.value && this.followUpForm.value.stage_id) ? this.followUpForm.value.stage_id : '',
                reason_id: (this.followUpForm.value && this.followUpForm.value.reason_id) ? this.followUpForm.value.reason_id : '',
                type: (this.followUpForm.value && this.followUpForm.value.type) ? this.followUpForm.value.type : '',
                subject: (this.followUpForm.value && this.followUpForm.value.subject) ? this.followUpForm.value.subject : '',
                remark: (this.followUpForm.value && this.followUpForm.value.remark) ? this.followUpForm.value.remark : '',
            };
            this.studentService.followUp(this.selectedStudent.id, params).subscribe(data => {

                if (data && data.id) {
                    this.followUps = [data, ...this.followUps];
                    this.followUps.forEach(followUp => {
                        if (followUp && followUp.reason_id) {
                            let selectedReason: any;
                            this.allReasons.forEach(allReason => {
                                if (allReason.id == followUp.reason_id) {
                                    selectedReason = allReason;
                                }
                            });
                            followUp['reason'] = selectedReason;
                        }
                        if (followUp && followUp.stage_id) {
                            let selectedStage: any;
                            this.allStages.forEach(allStage => {
                                if (allStage.id == followUp.stage_id) {
                                    selectedStage = allStage;
                                }
                            });
                            followUp['stage'] = selectedStage;
                        }
                    });
                    this.followUpForm.reset();
                    this.get();
                }
                this.modalService.dismissAll('');

            });
        }


    }

    viewFollowUpRemarks(content, sdata) {
        this.selectedStudent = sdata;
        this.studentService.getfollowUp(this.selectedStudent.id).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.followUps = data['data'];

                this.modalType = 'VIEW_FOLLOW_UP_REMARKS';
                this.modalService.open(content, {size: 'lg'});


            } else {
                this.followUps = [];
                this.followUps = data['data'];

                this.modalType = 'VIEW_FOLLOW_UP_REMARKS';
                this.modalService.open(content, {size: 'lg'});
            }

        });


    }
}
